import { render, staticRenderFns } from "./submitOrder.vue?vue&type=template&id=7ac95f64&scoped=true&"
import script from "./submitOrder.vue?vue&type=script&lang=ts&"
export * from "./submitOrder.vue?vue&type=script&lang=ts&"
import style0 from "./submitOrder.vue?vue&type=style&index=0&id=7ac95f64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac95f64",
  null
  
)

export default component.exports